window.SMTX.FeatureModuleImageCards = (function () {
  if ($('.feature-module-image-cards').length < 1) return;

  // Cache selectors for reusability and efficiency
  var $featureModuleImageCards = $('.feature-module-image-cards');
  var $featureCards = $('.feature-card', '.feature-module-image-cards');
  var cardHeight = getComputedStyle(document.documentElement).getPropertyValue('--feature-image-card-height');
  var cardPaddingTop = getComputedStyle(document.documentElement).getPropertyValue('--feature-image-card-padding-top');

  // Function to toggle card height
  var toggleContentHeight = (clickedCard, isActive) => {
    var $overlays = clickedCard.find('.feature-card--overlay');
    var childrenHeight = 0;

    $overlays.each((i, element) => {
      var elementHeight = $(element).data('element-height');
      childrenHeight += elementHeight;

      // Set max height based on active state
      $(element).css('max-height', isActive ? elementHeight : 0);
    });

    return childrenHeight;
  };

  // Function to calculate total height
  var calculateTotalHeight = (clickedCard, headlineHeight, childrenHeight) => {
    var elementPaddingTop = parseInt(clickedCard.css('padding-top'));
    var elementPaddingBottom = parseInt(clickedCard.css('padding-bottom'));
    return headlineHeight + childrenHeight + elementPaddingTop + elementPaddingBottom;
  };
  
  var isMobile = () => {
    return $(document).innerWidth() < 768;
  };
  
  var toggleHeadlineOffset = (element, state) => {
    var headlineContainer = $(element).find('.feature-card__headline-container');
    var headlineContainerSpacer = $(element).find('.feature-card__headline-container--spacer');
    var spacerPositionTop = headlineContainerSpacer.position().top;
    
    if (state === 'mouseenter') {
      // Set the spacer position as the top offset
      headlineContainer.css('top', spacerPositionTop);
      return;
    }

    if (state === 'mouseleave') {
      // Reset the top offset
      headlineContainer.css('top', cardPaddingTop);
      return;
    }
  };
  
  var init = () => {
    // Reset styles
    $('.feature-card__headline-container').removeAttr('style');
    $('.feature-card--overlay').removeAttr('style');
    
    $featureModuleImageCards.find('.feature-cards-grid').each((i, cardGridElement) => {
      var $cardGridElement = $(cardGridElement);
      
      $cardGridElement.find('.feature-card').each((l, cardElement) => {
        var $cardElement = $(cardElement);
        
        if (isMobile()) {
          // Store the first child's height for each overlay in the data attribute
          $cardElement.find('.feature-card--overlay').each((l, element) => {
            $cardOverlayElement = $(element);
            var $firstChild = $cardOverlayElement.children().first();
            $cardOverlayElement.data('element-height', $firstChild.outerHeight(true));
          });
          
          // Set the height of the card
          $cardElement.css('height', cardHeight);
        } else {
          // Reset the height
          $cardElement.css('height', '100%');
        } 
      });
    });
  };

  // Handle card hover events
  $featureCards.on('mouseenter', (e) => {
    if (isMobile()) return;
    
    toggleHeadlineOffset(e.currentTarget, 'mouseenter');
    $(e.currentTarget).addClass('active');
  });

  // Handle card hover events
  $featureCards.on('mouseleave', (e) => {
    if (isMobile()) return;
    
    $(e.currentTarget).removeClass('active');
    toggleHeadlineOffset(e.currentTarget, 'mouseleave');
  });

  // Handle card click event
  $featureCards.click((e) => {
    if (!isMobile()) return;

    var clickedCard = $(e.currentTarget);
    var isActive = clickedCard.toggleClass('active').hasClass('active');

    var headlineHeight = clickedCard.find('.feature-card__headline-container').outerHeight(true);
    var contentHeight = toggleContentHeight(clickedCard, isActive);
    var totalHeight = calculateTotalHeight(clickedCard, headlineHeight, contentHeight);
    var currentHeight = clickedCard.outerHeight(true);

    // Animate height changes
    if (isActive && totalHeight > currentHeight) {
      clickedCard.animate({ height: totalHeight }, 250);
    } else {
      clickedCard.animate({ height: cardHeight }, 250);
    }
  });
  
  
  var resizeTimer;
  $(window).resize(() => {
    // Debounce resize event
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      init();
      if ($featureCards.hasClass('active')) $featureCards.removeClass('active');
    }, 250);
  });

  return {};
})();

window.SMTX.FeatureModulePricing = (function () {
  if ($('.feature-module-pricing').length < 1) return;
  
  
  function alignToggleButtons() {
    $('.feature-module-pricing').each((i, pricingModule) => {
      if($('.feature-card__expand-toggle', pricingModule).length < 1) return;
      
      const $cards = $('.feature-cards-grid > .cell', pricingModule);
      const $toggleButtons = $('.feature-card__expand-toggle', pricingModule);
  
      // Temporarily disable transitions and reset margin-top
      $toggleButtons.css({
        'margin-top': '',
        'transition-duration': '0',
        'transition-property': 'none'
      });
      
      // Find all expanded containers and store them in an array
      const expandedContainers = [];
      $('.feature-card__list-container.is-expanded', pricingModule).each(function() {
        expandedContainers.push($(this));
        $(this).removeClass('is-expanded');
        $('.feature-card__list__collapsable', this).hide();
        void(this.offsetHeight);
      });
      $('.feature-card__list-container', pricingModule).each(function() {
        void(this.offsetHeight);
      })
  
      // Force a reflow to ensure the browser processes the style changes
      // Accessing offsetHeight forces the reflow
      $toggleButtons.each(function() {
        void(this.offsetHeight);
      });

      $toggleButtons.css({
        'margin-top': '',
        'transition-duration': '0',
        'transition-property': 'none'
      });
      
      // Fetch the default css margin-top value

      // Don't apply to small screens
      if($(window).innerWidth() >= 768) {
        $(pricingModule).data('max_y_offset', 0)
        // Calculate the maximum height of content above the toggle button
        $cards.each(function() {
          let $card = $(this);
          const $toggleButton = $('.feature-card__expand-toggle', $card);
          if ($toggleButton.length < 1) return;

          let max_y_offset = Number($(pricingModule).data('max_y_offset'));
          const card_y = $('.feature-card__inner', $card).offset().top;
          const button_y = $toggleButton.offset().top - card_y;

          if (button_y > max_y_offset) {
            max_y_offset = button_y;
            $(pricingModule).data('max_y_offset', max_y_offset);
          }
        });

        // Adjust the toggle buttons to align them
        $cards.each(function(j) {
          let $card = $(this);
          const $toggleButton = $('.feature-card__expand-toggle', $card);
          if ($toggleButton.length < 1) return;

          let max_y_offset = Number($(pricingModule).data('max_y_offset'));
          const defaultButtonMargin = parseInt($('.feature-card__expand-toggle', $card).css('margin-top'));
          const card_y = $('.feature-card__inner', $card).offset().top;
          const button_y = $toggleButton.offset().top - card_y;

          // Check if the button is below the max_y_offset
          if(button_y < max_y_offset) {
            // If there is a previous sibling, add the default margin-top
            let defaultMarginTop = 0;
            if ($toggleButton.prev().length) {
              defaultMarginTop = defaultButtonMargin;
            }
            
            // Calculate the margin-top to align the toggle button
            const marginTop = max_y_offset - button_y + defaultMarginTop;
            const marginTopRem = marginTop / 16;
            // Add margin-top to the toggle button to align it
            $toggleButton.css('margin-top', marginTopRem + 'rem');
          }
        });
        
      }
      
      // Re-add is-expanded class to expanded cards
      expandedContainers.forEach((container) => {
        container.addClass('is-expanded');
        $('.feature-card__list__collapsable', container).show();
        
        void($('.feature-card__list__collapsable', container).offsetHeight);
      });
      
      // Make sure the changes are rendered before re-enabling transitions
      window.requestAnimationFrame(() => {
        $toggleButtons.css({
          'transition-duration': '',
          'transition-property': ''
        });
      })  
    })
  }

  // Call the function on page load
  alignToggleButtons();

  // Re-align toggle buttons on window resize
  $(window).on('resize', function() {
    alignToggleButtons();
  });

  
  $('.feature-card__expand-toggle').on('click', function(e) {
    e.preventDefault(); 

    let $toggleButton = $(this);

    let $container = $toggleButton.closest('.feature-card__list-container');
    let $collapsable = $('.feature-card__list__collapsable', $container);

    $collapsable.slideToggle(300);

    $container.toggleClass('is-expanded');
  })
})();
